import { Injectable } from '@angular/core';
import * as createHyphenator from 'hyphen';
import { HyphenationFunctionSync } from 'hyphen';
//import * as patternsDe from 'hyphen/patterns/de';
//import * as patternsEn from 'hyphen/patterns/sk';
import { hyphenateSync as hyphenateEn } from "hyphen/en";
import { hyphenateSync as hyphenateDe } from "hyphen/de";

@Injectable({
  providedIn: 'root',
})
export class HyphenateService {

  private theme: string;
  private targetGroup: string;

  public setTheme(theme: string): void {
    this.theme = theme.toUpperCase().replace(/\s.*/, '');
    console.log("SET HYPHEN THEME " + this.theme);
  }

  public getTheme(): string {
    return this.theme;
  }

  public setTargetGroup(targetGroup: string): void {
    this.targetGroup = targetGroup.toUpperCase().replace(/\s.*/, '');
    console.log("SET HYPHEN TARGETGROUP " + this.targetGroup);
  }  
  
  public getTargetGroup(): string {
    return this.targetGroup;
  }  

  public hyphenate: HyphenationFunctionSync = hyphenateEn;/*<HyphenationFunctionSync>(
    createHyphenator(patternsEn)
  );*/

  public setHyphenateFunction(locale: string) {
    if (locale === 'de') {
      this.hyphenate = hyphenateDe;//<HyphenationFunctionSync>createHyphenator(patternsDe);
    } else {
      this.hyphenate = hyphenateEn//<HyphenationFunctionSync>createHyphenator(patternsEn);
    }
  }
}